import { EventSummaryReportTab } from 'types';
import { DrawerProps } from 'components/drawer';
import { Event, EventReport } from 'store/api/event';

export const TabTitles = {
  [EventSummaryReportTab.Refunds]: 'Refunds',
  [EventSummaryReportTab.Revenue]: 'Revenue',
  [EventSummaryReportTab.Expenses]: 'Expenses',
  [EventSummaryReportTab.CashFlow]: 'Cashflow',
  [EventSummaryReportTab.Dashboard]: 'Dashboard',
  [EventSummaryReportTab.Inventory]: 'Inventory',
  [EventSummaryReportTab.ProfitAndLosses]: 'P&L',
  [EventSummaryReportTab.Commissions]: 'Commissions',
  [EventSummaryReportTab.StockOrders]: 'Stock Orders',
  [EventSummaryReportTab.MissingSales]: 'Missing sales',
  // [EventSummaryReportTab.Received]: 'Money received',
  [EventSummaryReportTab.Bonuses]: 'Bonuses & Advances',
  [EventSummaryReportTab.Reimbursements]: 'Reimbursements',
};

export interface ExpensesProps extends CommonReportProps {
  event: Event;
}

export interface CommonReportProps {
  data: EventReport[];
}

export interface EventReportProps extends Pick<
  DrawerProps,
  'opened' | 'onClose'
> {
  event: Event;
  openedTab?: EventSummaryReportTab;
}
